// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.PurposeProfessionalsSection_purpose-section__pNfhX {
  padding: 28px 40px;
  background-color: transparent;
  font-family: "Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
}
@media (max-width: 767px) {
  .PurposeProfessionalsSection_purpose-section__pNfhX {
    padding: 28px 20px;
  }
}
@media (min-width: 1080px) {
  .PurposeProfessionalsSection_purpose-section__pNfhX {
    padding: 24px 40px;
  }
}

.PurposeProfessionalsSection_container__bilnv {
  max-width: 1240px;
  margin: 0 auto;
  background-color: #F7F5F1;
  border-radius: 32px;
  padding: 64px 24px;
  box-shadow: 0 16px 38px rgba(18, 34, 29, 0.04);
}
@media (min-width: 821px) {
  .PurposeProfessionalsSection_container__bilnv {
    padding: 44px 56px;
  }
}

.PurposeProfessionalsSection_top-row__nikUL {
  display: grid;
  grid-template-columns: minmax(280px, 0.9fr) minmax(360px, 1fr);
  row-gap: 16px;
  column-gap: clamp(36px, 6vw, 78px);
  align-items: end;
  margin-bottom: 36px;
}
@media (max-width: 900px) {
  .PurposeProfessionalsSection_top-row__nikUL {
    grid-template-columns: 1fr;
    gap: 32px;
  }
}

.PurposeProfessionalsSection_col-left__nt\\+2S {
  flex: 1 1;
  max-width: 500px;
}

.PurposeProfessionalsSection_col-right__bKZSR {
  flex: 1 1;
  max-width: 480px;
}

.PurposeProfessionalsSection_eyebrow__GoxOY {
  margin: 0 0 12px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: #82B194;
  text-transform: uppercase;
}

.PurposeProfessionalsSection_title__UFGNb {
  margin: 0;
  font-size: 36px;
  line-height: 1.1;
  font-weight: 700;
  letter-spacing: -0.025em;
  color: #13231D;
  white-space: normal;
}
@media (min-width: 1080px) {
  .PurposeProfessionalsSection_title__UFGNb {
    white-space: pre-line;
    font-size: 42px;
  }
}

.PurposeProfessionalsSection_description__6nJ25 {
  margin: 0;
  font-size: 15px;
  line-height: 1.6;
  color: #5F726B;
  font-weight: 400;
}
@media (min-width: 821px) {
  .PurposeProfessionalsSection_description__6nJ25 {
    font-size: 17px;
  }
}

.PurposeProfessionalsSection_cards-grid__EOlo4 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}
@media (min-width: 768px) {
  .PurposeProfessionalsSection_cards-grid__EOlo4 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;
  }
}

.PurposeProfessionalsSection_card__aODoQ {
  border: 1px solid rgba(0, 0, 0, 0.04);
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  padding: 26px 24px;
  display: grid;
  gap: 10px;
}

.PurposeProfessionalsSection_card-title__VfVg2 {
  margin: 0 0 2px;
  font-size: 18px;
  font-weight: 800;
  color: #13231D;
  line-height: 1.25;
}
@media (min-width: 821px) {
  .PurposeProfessionalsSection_card-title__VfVg2 {
    font-size: 22px;
  }
}

.PurposeProfessionalsSection_card-desc__\\+ZpnJ {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: #5F726B;
}
@media (min-width: 821px) {
  .PurposeProfessionalsSection_card-desc__\\+ZpnJ {
    font-size: 15.5px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/Landing/PurposeProfessionalsSection/PurposeProfessionalsSection.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AAdA;EACE,kBAAA;EACA,6BAAA;EACA,oFDCU;ACgBZ;AAfE;EALF;IAMI,kBAAA;EAkBF;AACF;AAhBE;EATF;IAUI,kBAAA;EAmBF;AACF;;AAhBA;EACE,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,8CAAA;AAmBF;AAjBE;EARF;IASI,kBAAA;EAoBF;AACF;;AAjBA;EACE,aAAA;EACA,8DAAA;EACA,aAAA;EACA,kCAAA;EACA,gBAAA;EACA,mBAAA;AAoBF;AAlBE;EARF;IASI,0BAAA;IACA,SAAA;EAqBF;AACF;;AAlBA;EACE,SAAA;EACA,gBAAA;AAqBF;;AAlBA;EACE,SAAA;EACA,gBAAA;AAqBF;;AAlBA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,yBAAA;AAqBF;;AAlBA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;EACA,mBAAA;AAqBF;AAnBE;EATF;IAUI,qBAAA;IACA,eAAA;EAsBF;AACF;;AAnBA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAsBF;AApBE;EAPF;IAQI,eAAA;EAuBF;AACF;;AApBA;EACE,aAAA;EACA,0BAAA;EACA,SAAA;AAuBF;AArBE;EALF;IAMI,gDAAA;IACA,SAAA;EAwBF;AACF;;AArBA;EACE,qCAAA;EACA,0CAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;AAwBF;;AArBA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAwBF;AAtBE;EAPF;IAQI,eAAA;EAyBF;AACF;;AAtBA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAyBF;AAvBE;EANF;IAOI,iBAAA;EA0BF;AACF","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../../assets/styles/variables';\n\n.purpose-section {\n  padding: 28px 40px;\n  background-color: transparent;\n  font-family: $font-main;\n\n  @media (max-width: 767px) {\n    padding: 28px 20px;\n  }\n\n  @media (min-width: 1080px) {\n    padding: 24px 40px;\n  }\n}\n\n.container {\n  max-width: 1240px;\n  margin: 0 auto;\n  background-color: #F7F5F1;\n  border-radius: 32px;\n  padding: 64px 24px;    \n  box-shadow: 0 16px 38px rgba(18, 34, 29, .04);\n\n  @media (min-width: 821px) {\n    padding: 44px 56px;\n  }\n}\n\n.top-row {\n  display: grid;\n  grid-template-columns: minmax(280px, .9fr) minmax(360px, 1fr);\n  row-gap: 16px;\n  column-gap: clamp(36px, 6vw, 78px);\n  align-items: end;\n  margin-bottom: 36px;\n\n  @media (max-width: 900px) {\n    grid-template-columns: 1fr;\n    gap: 32px;\n  }\n}\n\n.col-left {\n  flex: 1;\n  max-width: 500px;\n}\n\n.col-right {\n  flex: 1;\n  max-width: 480px;\n}\n\n.eyebrow {\n  margin: 0 0 12px;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  color: #82B194;\n  text-transform: uppercase;\n}\n\n.title {\n  margin: 0;\n  font-size: 36px;\n  line-height: 1.1;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  color: #13231D;\n  white-space: normal;\n\n  @media (min-width: 1080px) {\n    white-space: pre-line;\n    font-size: 42px;\n  }\n}\n\n.description {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.6;\n  color: #5F726B;\n  font-weight: 400;\n\n  @media (min-width: 821px) {\n    font-size: 17px;\n  }\n}\n\n.cards-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 20px;\n\n  @media (min-width: 768px) {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 20px;\n  }\n}\n\n.card {\n  border: 1px solid rgba(0, 0, 0, 0.04);\n  background-color: rgba(255, 255, 255, 0.3);\n  border-radius: 20px;\n  padding: 26px 24px;\n  display: grid;\n  gap: 10px;\n}\n\n.card-title {\n  margin: 0 0 2px;\n  font-size: 18px;\n  font-weight: 800;\n  color: #13231D;\n  line-height: 1.25;\n\n  @media (min-width: 821px) {\n    font-size: 22px;\n  }\n}\n\n.card-desc {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #5F726B;\n\n  @media (min-width: 821px) {\n    font-size: 15.5px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"purpose-section": `PurposeProfessionalsSection_purpose-section__pNfhX`,
	"container": `PurposeProfessionalsSection_container__bilnv`,
	"top-row": `PurposeProfessionalsSection_top-row__nikUL`,
	"col-left": `PurposeProfessionalsSection_col-left__nt+2S`,
	"col-right": `PurposeProfessionalsSection_col-right__bKZSR`,
	"eyebrow": `PurposeProfessionalsSection_eyebrow__GoxOY`,
	"title": `PurposeProfessionalsSection_title__UFGNb`,
	"description": `PurposeProfessionalsSection_description__6nJ25`,
	"cards-grid": `PurposeProfessionalsSection_cards-grid__EOlo4`,
	"card": `PurposeProfessionalsSection_card__aODoQ`,
	"card-title": `PurposeProfessionalsSection_card-title__VfVg2`,
	"card-desc": `PurposeProfessionalsSection_card-desc__+ZpnJ`
};
export default ___CSS_LOADER_EXPORT___;
